import React from "react"
import styled from "styled-components";
import Joako from "../assets/img/joako-pic.jpg";



const Profile = () => {

   return(
         <Biografy id="About">
           <img src={Joako} alt="Imagen Joako"/>
            <div className="about-cont">
              <h3 className="title ">About Me</h3>
              <p className="text-services">
                I am Joaquin Varela from Buenos Aires, Argentina. I am very fond of learning new technologies and programming languages. I am studying in a technical school, specialized in IT and Computer Science, but I have done many additional courses and trainings looking for expertise and specialization. I´ve been also working on web development area for 4 years now.
              </p>           
            </div>
          </Biografy> 
   );
}

export default Profile;

const Biografy = styled.div`  
padding-bottom: 1.8rem;

img{
  display: block;
  margin: 0 auto 1rem auto;
  border-radius: 1rem ;
  max-width: 70%;
}

@media(min-width: 560px){
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  img{
    max-width: 35%;
    border-radius: 0 6rem 6rem 0;
  }
}
.title{
  margin-left: 1.4rem;
  max-width: 93%;
}
.text-services{
  max-width: 93%;
  margin: 0 auto;
  text-align: justify;
  font-size: 17px;
  padding-bottom: 3rem;
}

`
